import {DEAL_STATUSES, OFFER_CATEGORIES} from '@chekin/core';
import {useSummary} from 'context/summary';
import {isActiveBooking, isLuggageStorageEnabled} from 'utils/upselling';
import {useFetchDeals} from './useFetchDeals';
import {isFirstLoad} from 'utils/query';

function useLuggageBookings() {
  const {reservationId} = useSummary();
  const isEnabled = isLuggageStorageEnabled();

  const dealsQuery = useFetchDeals({
    reservationId,
    category: OFFER_CATEGORIES.luggageServices,
    status: DEAL_STATUSES.paid,
    enabled: isEnabled,
  });

  const bookings = isEnabled
    ? (dealsQuery.data?.results ?? [])
        .map(deal => deal.radical_storage_booking)
        .filter((booking): booking is NonNullable<typeof booking> =>
          Boolean(booking?.pnr),
        )
    : [];

  const activeBookings = bookings.filter(isActiveBooking);
  const pastBookings = bookings.filter(booking => !isActiveBooking(booking));

  return {
    bookings,
    activeBookings,
    pastBookings,
    isLoading: isFirstLoad(dealsQuery),
    hasBookings: bookings.length > 0,
    hasActiveBookings: activeBookings.length > 0,
  };
}

export {useLuggageBookings};
